import React from 'react';

interface IfProps {
  loading?: boolean;
  condition: boolean | null | undefined;
  children: React.ReactNode;
  loadingContent?: React.ReactNode;
  emptyContent?: React.ReactNode;
}

const isEmptyObject = (obj: any) =>
  obj && typeof obj === 'object' && Object.keys(obj).length === 0;

const If: React.FC<IfProps> = ({
  loading,
  condition,
  children,
  loadingContent,
  emptyContent
}) => {
  if (loading) {
    return <>{loadingContent}</>;
  }

  if (
    !condition ||
    React.Children.count(children) === 0 ||
    isEmptyObject(children)
  ) {
    return <>{emptyContent}</>;
  }

  return <>{children}</>;
};

export default If;
